import type { RichTextMentionData } from "./RichTextMentionPlugin";

export interface MentionSuggestionSection {
  readonly key: string;
  readonly title: string;
  readonly items: readonly RichTextMentionData[];
}

const DEFAULT_MAX_ITEMS_PER_SECTION = 5;

interface BuildProjectsTablesAndSemanticSectionsOptions {
  readonly includeEmptySections?: boolean;
  readonly maxItemsPerSection?: number;
}

export function buildProjectsTablesAndSemanticSections(
  suggestions: readonly RichTextMentionData[],
  options: BuildProjectsTablesAndSemanticSectionsOptions = {},
): MentionSuggestionSection[] {
  const {
    includeEmptySections = false,
    maxItemsPerSection = DEFAULT_MAX_ITEMS_PER_SECTION,
  } = options;
  const projectItems = suggestions
    .filter((suggestion) => suggestion.mentionType === "hex")
    .slice(0, maxItemsPerSection);
  const tableItems = suggestions
    .filter((suggestion) => suggestion.mentionType === "table")
    .slice(0, maxItemsPerSection);
  const semanticItems = suggestions
    .filter(
      (suggestion) =>
        suggestion.mentionType === "semantic_dataset" ||
        suggestion.mentionType === "semantic_view",
    )
    .slice(0, maxItemsPerSection);

  const sections = [
    { key: "projects", title: "Projects", items: projectItems },
    { key: "tables", title: "Tables", items: tableItems },
    {
      key: "semantic-models",
      title: "Models",
      items: semanticItems,
    },
  ];

  return includeEmptySections
    ? sections
    : sections.filter((section) => section.items.length > 0);
}

export function flattenMentionSuggestionSections(
  sections: readonly MentionSuggestionSection[],
): RichTextMentionData[] {
  return sections.flatMap((section) => section.items);
}
